<template>
  <div>
    <PageAllow controller="ShopDailyReports" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="overflow-y-scroll fill-content-height">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRangeWithRadio
              v-model="options"
              type="datetime"
              show-radios
              :radios="datetimeRadios"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <!-- 销售日结生成 -->
            <v-btn
              v-if="
                settings && settings.shop_daily_ext_pull &&
                $permission.permissionAllow('ShopDailyReports', 'extPull')
              "
              small
              color="print"
              dark
              @click.stop="shopDailyExtPullDialog = true"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("shopDailyReports.shopDailyExtPull") }}
            </v-btn>
            <!-- 导入 -->
            <v-btn
              v-if="$permission.permissionAllow('ShopDailyReports', 'import')"
              small
              color="print"
              dark
              @click.stop="ImportDialog = true"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-file-import</v-icon>
              {{ $t("shopDailyReports.import") }}
            </v-btn>
            <!-- 导出 -->
            <v-btn
              small
              v-if="$permission.permissionAllow('ShopDailyReports', 'export')"
              color="print"
              dark
              @click.stop="exportExcel()"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("shopDailyReports.export", [$consts.shopName()]) }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="shop_keyword"
                  v-model="options.keyword"
                  @text="shopKeyword = $event"
                  :label="
                    $t('shopDailyReports.shopKeyword', [$consts.shopName()])
                  "
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherDistrictsWithDescendants
                  v-model="DistrictsSelected"
                  :label="
                    $t('shopDailyReports.shopDistricts', [$consts.shopName()])
                  "
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="shopDailyReports"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-1 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <!-- 合计 -->
          <template v-slot:body.prepend>
            <tr class="d-none d-sm-table-row">
              <td colspan="3">
                <span>{{ $t("TableSum") }}</span>
              </td>
              <td>
                <span>{{ saleNumTotal | formatTwoDot }}</span>
              </td>
              <td colspan="4"></td>
            </tr>
              <!-- 小屏幕 -->
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("shopDailyReports.Fields.sales_num") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ saleNumTotal | formatTwoDot }}
                  </div>
                </td>
              </tr>
            </template>

          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.shop_name="{ item }">
            {{
              $t("shopDailyReports.shopNameWithStandard", [
                item.shop.shop_code,
                item.shop.shop_name,
              ])
            }}
          </template>
          <template v-slot:item.order_code="{ item }">
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.order_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.created | formatTime }}
            </span>
          </template>
          <template v-slot:item.business_date="{ item }">
            <span>
              {{ item.business_date | formatDate }}
            </span>
          </template>
          <template v-slot:item.sales_volume="{ item }"
            >{{ $t("Global.money") }}
            {{ item.sales_volume | formatMoney }}</template
          >
          <template v-slot:item.actual_sales_volume="{ item }"
            >{{ $t("Global.money") }}
            {{ item.actual_sales_volume | formatMoney }}</template
          >
          <template v-slot:item.operator="{ item }">
            {{ item.created_name }}</template
          >
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-if="$permission.permissionAllow('ShopDailyReports', 'view')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="secondary"
                  class="px-1 py-4 me-1"
                  @click="$router.push('/shop-daily-reports/' + item.id)"
                  :href="'/#/shop-daily-reports/' + item.id"
                  >fa-file-alt
                </v-icon>
              </template>
              <span>{{ $t("shopDailyReports.viewInfo") }}</span>
            </v-tooltip>
            <v-tooltip
              top
              v-if="
                $permission.permissionAllow('ShopDailyReports', 'detailExport')
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="print"
                  class="px-1 py-4 me-1"
                  @click="detailExports(item.id)"
                  >fa-file-excel
                </v-icon>
              </template>
              <span>{{ $t("shopDailyReports.Export.excel") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <ImportExcelAlert
      v-model="ImportDialog"
      :title="$t('shopDailyReports.importDaily')"
      :objName="$t('shopDailyReports.daily')"
      downloadTemplateUrl="download/template/shop_daily_reports_template.xlsx"
      @import="
        excelFile = $event;
        importExcel();
      "
    />
    <ImportResult
      v-model="importResultFlg"
      :errData="importResult"
      @close="
        importResultFlg = false;
        getShopDailyReportsFromAPI();
      "
    />
    <ShopDailyExtPull
      v-model="shopDailyExtPullDialog"
      @extPull="shopDailyExtPullDialog = false;"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";
import ShopDailyReports from "@/api/shop_daily_reports";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";
import consts from "@/consts";
import ImportResult from "./plugins/ImportResult";
import ShopDailyExtPull from "./plugins/ShopDailyExtPull";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  business_time_from: "",
  business_time_to: "",
  keyword: "",
  district_ids: [],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherDistrictsWithDescendants,
    ImportExcelAlert,
    ImportResult,
    ShopDailyExtPull,
  },
  data: () => ({
    options: JSON.parse(JSON.stringify(defaultOptions)),
    shopKeyword: "",
    DistrictsSelected: [],
    shopDailyReports: [],
    saleNumTotal: null,
    paging: {},
    ImportDialog: false,
    excelFile: null,
    importResultFlg: false,
    importResult: [],
    shopDailyExtPullDialog: false,
  }),
  mounted() {
    this.$commonUtils
      .loadOptions("shopDailyReports", ["DistrictsSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            this.options.page = 1;
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.shopDailyReports", [consts.shopName()]),
        disabled: true,
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("shopDailyReports.created_time"),
      },
      {
        key: "business",
        text: i18n.t("shopDailyReports.business_time"),
      },
    ],
    headers: () => [
      {
        text: i18n.t("shopDailyReports.Fields.order_code"),
        align: "start",
        sortable: false,
        value: "order_code",
      },
      {
        text: i18n.t("shopDailyReports.Fields.business_date"),
        align: "start",
        sortable: false,
        value: "business_date",
      },
      {
        text: i18n.t("shopDailyReports.Fields.shop_name"),
        align: "start",
        sortable: false,
        value: "shop_name",
      },
      {
        text: i18n.t("shopDailyReports.Fields.sales_num"),
        align: "start",
        sortable: false,
        value: "sales_num",
      },
      {
        text: i18n.t("shopDailyReports.Fields.sales_volume"),
        align: "start",
        sortable: false,
        value: "sales_volume",
      },
      {
        text: i18n.t("shopDailyReports.Fields.actual_sales_volume"),
        align: "start",
        sortable: false,
        value: "actual_sales_volume",
      },
      {
        text: i18n.t("shopDailyReports.Fields.operator"),
        align: "start",
        sortable: false,
        value: "operator",
      },
      {
        text: i18n.t("shopDailyReports.Fields.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    ...mapState(["loading", "districtID", "settings"]),
  },
  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.shopKeyword,
      });
    },
    resetSearch() {
      this.DistrictsSelected = [];
      this.saleNumTotal = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.shop_keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    getShopDailyReportsFromAPI() {
      ShopDailyReports.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shopDailyReports = response.data.shop_daily_orders;
            this.saleNumTotal = response.data.sale_num_total;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },

    exportExcel() {
      ShopDailyReports.exports(this.options);
    },
    detailExports(id) {
      ShopDailyReports.detailExports(id);
    },

    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      ShopDailyReports.imports(this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              if (response.data.err_data && response.data.err_data.length) {
                this.ImportDialog = false;
                this.importResultFlg = true;
                this.importResult = response.data.err_data;
              } else {
                this.$snackbar.info(
                  i18n.t("Import.success", [
                    i18n.t("shopDailyReports.dailyReports"),
                  ])
                );
                this.ImportDialog = false;
                this.getShopDailyReportsFromAPI();
              }
            }

            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getShopDailyReportsFromAPI();
        sessionStorage.setItem(
          "shopDailyReports-options",
          JSON.stringify(this.options)
        );
      },
    },
    //门店分组
    DistrictsSelected: {
      handler() {
        this.options.district_ids = this.DistrictsSelected
          ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "shopDailyReports-DistrictsSelected",
          JSON.stringify(this.DistrictsSelected)
        );
      },
    },
    ImportDialog: {
      handler() {
        if (!this.ImportDialog && this.excelFile) {
          this.excelFile = null;
        }
      },
    },
  },
};
</script>
